import { useMutation } from "@apollo/client";

import { Button } from "../../../../../../../components/ui";
import { DELETE_PHOTO_MATERIAL } from "../../../../../../../graphql/mutation/PhotoMaterial";

const DeleteRecord = props => {
  const { closeModal, materialId } = props;
  const [deletePhotoMaterial, { loading, error, reset }] = useMutation(
    DELETE_PHOTO_MATERIAL,
    { refetchQueries: ["FetchPhotoMaterialsV2"] },
  );

  const handleDelete = async () => {
    const response = await deletePhotoMaterial({
      variables: { input: { id: materialId } },
    });

    if (response?.data?.deletePhotoMaterial?.success) {
      reset();
      closeModal();
    }
  };

  if (error) {
    return (
      <>
        <div className="mt-3 inline-flex items-center justify-start rounded-md border border-transparent px-4 py-2 font-bold font-medium text-red-800 sm:text-sm">
          {error?.message ||
            error?.graphQLErrors?.map?.(({ message }) => `${message} `) ||
            "An error occurred"}
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            className="mr-3"
            label="Close"
            onClick={() => {
              reset();
              closeModal();
            }}
          />
        </div>
      </>
    );
  }

  return (
    <div className="mt-4 flex justify-end">
      <Button
        className="mr-3"
        label="Cancel"
        onClick={() => {
          closeModal();
        }}
      />
      <Button
        label={loading ? "Deleting" : "Delete"}
        disabled={loading}
        onClick={handleDelete}
      />
    </div>
  );
};

export default DeleteRecord;
